//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';

import { ILike2BuyStoreData } from '@apis/like2buy/like2buyStoreApiModel';
import Cuid from '@models/Cuid';
import { IRightsPermissions } from '@models/IItemMetadata';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { hasPermissionForTask } from '@services/permissions';
import { Normalized } from '@utils/normalize';

export interface ILike2BuyModerationState {
  connectedStore?: ILike2BuyStoreData;
  items: NormalizedLike2BuyItems;
  rightsPermissionsByCuid: RightsPermissionsByCuid;
  itemFilter: Like2BuyModerationItemFilter;
  totalItemCount: number;
  pinnedItemCuids: Cuid[];
  flags: {
    isInitialLike2BuyDataLoaded: boolean;
    isFetchingInitialItems: boolean;
    isFetchingNextItems: boolean;
    hasFetchedAllItems: boolean;
    isFetchingPreviewUrl: boolean;
    isFetchingPinnedItems: boolean;
    isFetchingLike2BuyStore: boolean;
  };
  errors: {
    fetchItemsError?: string;
    fetchStoreError?: string;
    fetchPreviewUrlError?: string;
    fetchPinnedItemsError?: string;
    fetchRightsRequestStatusError?: string;
  };
}

export type NormalizedLike2BuyItems = Normalized<IMlsMediaItem, Cuid>;

export const L2B_ITEM_REQUEST_LIMIT = 50;

export enum Like2BuyModerationStatus {
  Hidden = 'Hidden',
  NeedsProducts = 'NeedsProducts',
  Pinned = 'Pinned',
  Published = 'Published',
}

export type Like2BuyModerationItemFilter =
  | Like2BuyModerationStatus
  | 'allMedia';

export type RightsPermissionsByCuid = PojoMap<Cuid, IRightsPermissions>;

export function isLike2BuyModerationStatus(
  itemFilter: Like2BuyModerationItemFilter,
): itemFilter is Like2BuyModerationStatus {
  return itemFilter in Like2BuyModerationStatus;
}

export const L2B_MODERATE_TASK = 'like2buy:moderate';
export const hasLike2BuyModerationPermission = () =>
  hasPermissionForTask(L2B_MODERATE_TASK);
